
// vue
import { defineComponent } from 'vue';

// atoms
import CustomButton from '@/components/atoms/CustomButton.vue';
import Heading from '@/components/atoms/Heading.vue';

export default defineComponent({
  name: 'HeaderMenu',
  components: {
    CustomButton,
    Heading,
  },
  props: {
    showHeaderMenu: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup() {},
});
